var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThirdBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.636 44.2651V38.5511C13.04 32.5971 6 29.4091 6 20.2651C6 11.1251 11.454 4.15314 22.364 4.26514C30.218 4.34914 37.636 8.83714 37.636 17.9811L42 24.8371C42 29.4091 37.636 29.4091 37.636 29.4091C37.636 29.4091 38.728 40.8371 28.908 40.8371V44.2651",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24.2651C23.0609 24.2651 24.0783 23.8437 24.8284 23.0936C25.5786 22.3434 26 21.326 26 20.2651C26 19.2043 25.5786 18.1869 24.8284 17.4367C24.0783 16.6866 23.0609 16.2651 22 16.2651C20.9391 16.2651 19.9217 16.6866 19.1716 17.4367C18.4214 18.1869 18 19.2043 18 20.2651C18 21.326 18.4214 22.3434 19.1716 23.0936C19.9217 23.8437 20.9391 24.2651 22 24.2651Z",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26.2651C23.5913 26.2651 25.1174 25.633 26.2426 24.5078C27.3679 23.3826 28 21.8564 28 20.2651C28 18.6738 27.3679 17.1477 26.2426 16.0225C25.1174 14.8973 23.5913 14.2651 22 14.2651C20.4087 14.2651 18.8826 14.8973 17.7574 16.0225C16.6321 17.1477 16 18.6738 16 20.2651C16 21.8564 16.6321 23.3826 17.7574 24.5078C18.8826 25.633 20.4087 26.2651 22 26.2651Z",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.6 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdBadge);
export default __webpack_public_path__ + "static/media/thirdBadge.4e9a5aa7cea045366e69f60ca0a6afdf.svg";
export { ForwardRef as ReactComponent };